// This file is generated.
export var version = '0.3.2';
//# sourceMappingURL=version.js.map